import { Search } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/design-system/lib/cn';

export type InputProps = ComponentProps<'input'> & {
  /** Marca o campo como inválido: borda de erro e `aria-invalid` para leitor de tela. */
  invalid?: boolean;
};

/**
 * Campo de texto: 40px, raio de controle, borda `line-input`. O rótulo é responsabilidade
 * de quem usa (`<label>` envolvendo ou `htmlFor`).
 */
export function Input({ className, invalid = false, ...props }: InputProps) {
  return (
    <input
      data-slot="input"
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full min-w-0 rounded-control border bg-white px-3 text-control text-ink max-md:text-small',
        'placeholder:text-ink-placeholder disabled:bg-surface-subtle disabled:text-ink-subtle',
        invalid ? 'border-status-conflict' : 'border-line-input',
        className
      )}
      {...props}
    />
  );
}

export type SearchInputProps = Omit<InputProps, 'type'> & { 'aria-label': string };

/** Campo de busca com a lupa à esquerda. */
export function SearchInput({ className, ...props }: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Search
        aria-hidden
        className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 stroke-[1.8] text-ink-placeholder"
      />
      <Input type="search" className="pl-9 text-control max-md:text-small" {...props} />
    </div>
  );
}
